import { s as script } from './Icon-fJqkx1gN.js';
import { a as registerComponent } from './plugins-C7548x21.js';
import './config-nHWiBviw.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';
import 'vue';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};

export { script as BIcon, Plugin as default };
